import script from "./ItemSelectModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ItemSelectModal.vue?vue&type=script&setup=true&lang=js"

import "./ItemSelectModal.vue?vue&type=style&index=0&id=d88037dc&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d88037dc"]])

export default __exports__